import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import { Field, FormikProvider, useFormik } from "formik";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import * as Yup from "yup";
import {
  POST_CameraActiveInActive,
  POST_CameraDelete,
  POST_CameraExport,
  POST_GetCameraList,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import { delete_Record, ActiveInactive_Record } from "../CommonFunctions";

import { errorMessage } from "../CommonFunctions";

const Camera = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");
  const [cameraList, setCameraList] = useState([]);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Search: "",
      Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, Status },
  } = formikFilter;

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };

    await post(POST_GetCameraList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setCameraList(response?.List);
        setIsLoading(false);

        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const exportReport = () => {
    setIsLoading(true);

    let payload = {
      Search: Search,
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };
    post(POST_CameraExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Camera</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 96 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 96 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-camera"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Camera
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Search"
                              name="Search"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Status"
                              name="Status"
                              placeholder={"Select Status"}
                              options={statusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="Camera-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="Camera-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="4%"></th>
                        <th
                          style={{
                            width: "25%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ModelNo");
                          }}
                        >
                          Model No{" "}
                          <span className="ml-1">
                            {sortBy == "ModelNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("SerialNo");
                          }}
                        >
                          Serial No{" "}
                          <span className="ml-1">
                            {sortBy == "SerialNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "20%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("SourceSize");
                          }}
                        >
                          Source Size{" "}
                          <span className="ml-1">
                            {sortBy == "SourceSize" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "18%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("Isotope");
                          }}
                        >
                          Isotope{" "}
                          <span className="ml-1">
                            {sortBy == "Isotope " ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {cameraList?.length > 0 ? (
                        cameraList?.map((item, indx) => (
                          <tr key={indx}>
                            <td>
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 96 && x?.IsEdit
                              )?.length > 0 ? (
                                <Link
                                  to={`/edit-camera/${window.btoa(
                                    item.CameraIDEncrypt
                                  )}`}
                                  className="icon-box icon-box-md me-1"
                                  title="Edit"
                                >
                                  {SVGICON.EditPrimary}
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 96 && x?.IsActive
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  className={`icon-box icon-box-md me-1`}
                                  title={
                                    item.IsActive == true
                                      ? "Active"
                                      : "Inactive"
                                  }
                                  onClick={() => {
                                    ActiveInactive_Record(
                                      item.IsActive,
                                      POST_CameraActiveInActive,
                                      {
                                        CameraIDEncrypt: item.CameraIDEncrypt,
                                        IsActive: !item.IsActive,
                                        ModifiedByEncrypted:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      item.ModelNo
                                    );
                                  }}
                                >
                                  <i
                                    className={`fa fa-circle fs-15 ${
                                      item.IsActive == true
                                        ? "text-success"
                                        : "text-danger"
                                    }`}
                                  ></i>
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 96 && x?.IsDelete
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Delete"
                                  onClick={() => {
                                    delete_Record(
                                      POST_CameraDelete,
                                      {
                                        CameraIDEncrypt: item.CameraIDEncrypt,
                                        ModifiedByEncrypted:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      item.ModelNo
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>{item.ModelNo}</td>
                            <td>{item.SerialNo}</td>
                            <td>{item.SourceSize}</td>
                            <td style={{ textAlign: "left" }}>
                              {item.Isotope}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default Camera;
